"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var js_expansion_1 = require("js-expansion");
function redirect(page) {
    window.location.href = page;
}
function channel(ctx) {
    var query = ctx.query, req = ctx.req, res = ctx.res;
    if (query.channel_id && res) {
        js_expansion_1.Cookies.withExpress(req, res).write('channel_id', query.channel_id, {
            sameSite: 'lax',
            secure: false,
        });
        return query.channel_id;
    }
    return js_expansion_1.Cookies.withExpress(req, res).read('channel_id') || null;
}
function authenticated(user, force_login, permission, force_channel) {
    if (!user.id && force_login) {
        var returnUrl = window.location.pathname;
        redirect(process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/login?return=" + returnUrl);
        return false;
    }
    if (permission !== '' && !user.permissions.includes(permission)) {
        redirect(process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/profile");
        return false;
    }
    if (force_channel && !user.channel.id) {
        redirect(process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/profile");
        return false;
    }
    return true;
}
function Auth(AuthComponent, force_login, permission, force_channel) {
    var _this = this;
    if (force_login === void 0) { force_login = false; }
    if (permission === void 0) { permission = ''; }
    if (force_channel === void 0) { force_channel = false; }
    function Authenticated(props) {
        var channel_id = props.channel_id, cookie_channel_id = props.cookie_channel_id;
        var _a = react_1.useState(true), loading = _a[0], setLoading = _a[1];
        var _b = react_1.useState({ permissions: [], channel: {} }), user = _b[0], setUser = _b[1];
        react_1.useEffect(function () {
            var token = process.env.NEXT_PUBLIC_STORYBOOK_USER_TOKEN;
            var params = channel_id || cookie_channel_id ? { channel_id: channel_id || cookie_channel_id } : {};
            var Fetch = ra_fetch_1.Fetcher.api('auth');
            if (token) {
                Fetch.bearerToken(token);
            }
            Fetch.show('user', params).then(function (response) {
                var user = response.data;
                if (!authenticated(user, force_login, permission, force_channel)) {
                    return;
                }
                if (!user.id) {
                    return setLoading(false);
                }
                if (user.channel.id) {
                    ra_fetch_1.Fetcher.api('backend')
                        .show('user.channel', { id: user.channel.id, channel_id: user.channel.id })
                        .then(function (response) {
                        user.channel = __assign(__assign({}, user.channel), response.data);
                        setUser(user);
                        setLoading(false);
                    });
                }
                else {
                    setUser(user);
                    setLoading(false);
                }
            });
        }, []);
        if (force_login && loading) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return react_1.default.createElement(AuthComponent, __assign({}, props, { user: user, user_loading: loading, setUser: setUser }));
    }
    Authenticated.getInitialProps = function (ctx) { return __awaiter(_this, void 0, void 0, function () {
        var query, response, _a, cookie_channel_id;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    query = ctx.query;
                    if (!AuthComponent.getInitialProps) return [3 /*break*/, 2];
                    return [4 /*yield*/, AuthComponent.getInitialProps(__assign({}, ctx))];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = {};
                    _b.label = 3;
                case 3:
                    response = _a;
                    cookie_channel_id = channel(ctx);
                    return [2 /*return*/, __assign(__assign({}, response), { query: query, cookie_channel_id: cookie_channel_id })];
            }
        });
    }); };
    return Authenticated;
}
exports.default = Auth;
